module.exports = __webpack_public_path__ + "static/media/recruiting.990e6e1d.svg";